import React, { FC } from 'react';
import cx from 'clsx';
import { useTranslation } from 'react-i18next';
import { Icon } from './Icon';
import { SmartLink } from './SmartLink';
import { CART_WIDGET_TEST_IDS } from 'routes/Menu/MenuHeader/CartWidget/const';
import styles from './NoItemsCartWidget.module.scss';

type NoItemsCartWidgetProps = {
  classNames?: string;
  content?: JSX.Element;
  tableOrderItemCount: number;
};

export const NoItemsCartWidget: FC<NoItemsCartWidgetProps> = ({ classNames, content, tableOrderItemCount, ...props }) => {
  const { t } = useTranslation();

  if (tableOrderItemCount > 0) {
    return (
      <div className={classNames}>
        <SmartLink
          to={'~running-order'}
          className={cx(classNames, styles.review)}
          data-testid={CART_WIDGET_TEST_IDS.cartPreview}
          {...props}
        >
          <span>{t('cart.reviewOrder')}</span>
          <Icon className={styles.arrowIcon} name="leftArrow" size={16}></Icon>
        </SmartLink>
      </div>
    );
  }

  return (
    <div className={classNames} data-testid={CART_WIDGET_TEST_IDS.root} {...props}>
      {content}
    </div>
  );
};
